import {useTheme} from "vuetify";

export default function () {
  const theme = useTheme()
  const mediaQueryListObject = window.matchMedia('(prefers-color-scheme: dark)');

  mediaQueryListObject.addEventListener('change', prefersDarkScheme);

  prefersDarkScheme();

  function prefersDarkScheme(): void {
    setTheme(
      mediaQueryListObject.matches
        ? 'dark'
        : 'light'
    );
  }

  const isDarkTheme = computed(() => {
    return theme.global.name.value === 'dark'
  })

  function setTheme(value: string): void {
    // @ts-ignore
    theme.change(value)
  }

  function setDarkModeConf(value: number): void {
    if (value !== 2) {
      mediaQueryListObject.removeEventListener('change', prefersDarkScheme);
    }
    if (value === 0) {
      setTheme('light')
    } else if (value === 1) {
      setTheme('dark')
    } else if (value === 2) {
      prefersDarkScheme();
      mediaQueryListObject.addEventListener('change', prefersDarkScheme);
    } else {
      setTheme('light')
    }

    useLocalStorage().setItem('dark', value)
  }

  const darkModeConf = ref(0)

  onMounted(() => {
    const themeValue = useLocalStorage().getItem('dark');

    if (typeof themeValue !== undefined) {
      darkModeConf.value = Number(themeValue)
      setDarkModeConf(themeValue)
    }
  })

  watch(darkModeConf, (value) => setDarkModeConf(value))

  return {
    isDarkTheme,
    darkModeConf
  }
}
